export default "__VITE_ASSET__BSF39a0I__"